'use client'
// РУКА 1. Рабочая форма входа по коду (тексты — из макета). Ло и Има могут вставить её к себе как есть
// или сделать свою разметку на том же действии loginAction (./login/actions).
import { useActionState, useEffect, useState } from 'react'
import { loginAction, type LoginState } from './login/actions'
import { RESEND_AFTER_SEC } from './login/limits'

const field = 'w-full border border-line rounded-card px-4 py-3 text-lg bg-card focus:outline-none focus:border-aq'
const button = 'w-full bg-btn hover:bg-btn-h text-white font-semibold rounded-card px-4 py-3 disabled:opacity-60'

export function LoginForm({ redirectTo = '/' }: { redirectTo?: string }) {
  const [state, act, pending] = useActionState(loginAction, { step: 'phone' } as LoginState)
  const [otherNumber, setOtherNumber] = useState(false)
  const wait = useCountdown(state.sentAt)

  if (state.step === 'phone' || otherNumber) {
    return (
      <form action={(f) => { setOtherNumber(false); act(f) }} className="space-y-3">
        <input type="hidden" name="intent" value="send" />
        <p className="text-mute">Вход — это и регистрация. Без пароля, по коду из СМС</p>
        <input name="phone" type="tel" inputMode="tel" autoComplete="tel" required placeholder="+7 999 123-45-67"
          defaultValue={state.phone ?? ''} className={field} />
        {state.error && !otherNumber && <p className="text-cu-d text-sm">{state.error}</p>}
        <button disabled={pending} className={button}>{pending ? 'Отправляем…' : 'Получить код'}</button>
      </form>
    )
  }

  return (
    <div className="space-y-3">
      <form action={act} className="space-y-3">
        <input type="hidden" name="intent" value="confirm" />
        <input type="hidden" name="phone" value={state.phone} />
        <input type="hidden" name="redirectTo" value={redirectTo} />
        <p className="text-mute">Код отправлен на {state.phone}</p>
        {state.shownCode ? <ShownCode code={state.shownCode} /> : null}
        <input name="code" inputMode="numeric" autoComplete="one-time-code" pattern="\d{4}" maxLength={4} required
          placeholder="Код — 4 цифры" className={`${field} tracking-[0.5em] placeholder:tracking-normal text-center`} autoFocus />
        {state.error && <p className="text-cu-d text-sm">{state.error}</p>}
        <button disabled={pending} className={button}>{pending ? 'Проверяем…' : 'Войти'}</button>
      </form>
      <form action={act}>
        <input type="hidden" name="intent" value="send" />
        <input type="hidden" name="phone" value={state.phone} />
        <button disabled={wait > 0 || pending} className="text-sm text-aq-d hover:underline disabled:text-mute disabled:no-underline">
          {wait > 0 ? `Отправить снова через ${wait} сек.` : 'Отправить код снова'}
        </button>
      </form>
      <button type="button" onClick={() => setOtherNumber(true)} className="text-sm text-mute hover:underline">← Другой номер</button>
    </div>
  )
}

// Тестовый сайт: СМС ещё не подключены, поэтому код показываем здесь (Д-8). На сайте заказчика его нет.
function ShownCode({ code }: { code: string }) {
  const [copied, setCopied] = useState(false)
  return (
    <div className="flex items-center justify-between gap-3 rounded-card border border-dashed border-line bg-bg px-4 py-3">
      <span className="text-sm text-mute">
        Тестовый сайт — СМС пока не приходят. Ваш код: <b className="text-ink text-lg tracking-[0.3em] tabular-nums">{code}</b>
      </span>
      <button
        type="button"
        className="text-sm font-semibold text-aq-d hover:underline whitespace-nowrap"
        onClick={() => {
          navigator.clipboard?.writeText(code).then(() => setCopied(true), () => setCopied(false))
        }}
      >
        {copied ? 'Скопировано' : 'Скопировать'}
      </button>
    </div>
  )
}

function useCountdown(sentAt?: number) {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(t)
  }, [])
  return sentAt ? Math.max(0, RESEND_AFTER_SEC - Math.floor((now - sentAt) / 1000)) : 0
}
